<template>
  <div v-if="egress_profile">
    <!-- <AchievementRangeGroupSelector
      class="mt-2"
      :egress_profile_id="egress_profile.id"
      @selected_range_group="selectedRangeGroup"
    ></AchievementRangeGroupSelector> -->
    <AssessmentGroupEvaluationCriteriaTable
      :key="selected_achievement_range_group"
      :egress_profile="egress_profile"
      :egress_profile_matter="egress_profile_matter"
      :campuses_="campuses_"
      :study_units_="study_units_"
      :periods_="periods_"
      :student_status_="student_status_"
      :achievement_range_group="selected_achievement_range_group"
    >
    </AssessmentGroupEvaluationCriteriaTable>
  </div>
</template>

<script>
// import * as names from "@/store/names";
// import { mapGetters } from "vuex";
export default {
  name: "AssessmentGroupStudyUnit",
  components: {
    AssessmentGroupEvaluationCriteriaTable: () =>
      import(
        "@/components/reports/TeachingReport/AssessmentGroupEvaluationCriteria/AssessmentGroupEvaluationCriteriaTable"
      ),
    // AchievementRangeGroupSelector: () =>
    //   import(
    //     "@/components/reports/TeachingReport/AchievementRangeGroupSelector.vue"
    //   ),
  },
  props: {
    egress_profile: {
      type: Object,
      required: true,
    },
    egress_profile_matter: {
      type: Object,
      required: true,
    },
    campuses_: {
      type: Array,
    },
    study_units_: {
      type: Array,
    },
    periods_: {
      type: Array,
    },
    student_status_: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selected_achievement_range_group: null,
      show_assessment_range_table: false,
    };
  },
  computed: {},
  methods: {
    selectedRangeGroup(achievement_range_group_id) {
      this.selected_achievement_range_group = achievement_range_group_id;
      this.show_assessment_range_table = true;
    },
  },
  created() {},
};
</script>

<style scoped>
</style>

